import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/authService';

const AuthContext = createContext(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Load user on mount
    useEffect(() => {
        loadUser();
    }, []);

    const loadUser = async () => {
        setLoading(true);
        try {
            const userData = await authService.me();
            setUser(userData);
        } catch (error) {
            console.error('Failed to load user:', error);
            setUser(null);
        } finally {
            setLoading(false);
        }
    };

    const login = async (email, password) => {
        const result = await authService.login(email, password);
        if (result.ok) {
            await loadUser();
        }
        return result;
    };

    const register = async (email, password) => {
        const result = await authService.register(email, password);
        if (result.ok) {
            await loadUser();
        }
        return result;
    };

    const logout = async () => {
        await authService.logout();
        setUser(null);
    };

    const verifyEmail = async (token) => {
        const result = await authService.verifyEmail(token);
        if (result.ok) {
            await loadUser();
        }
        return result;
    };

    const resendVerification = async (email) => {
        return await authService.resendVerification(email);
    };

    const value = {
        user,
        loading,
        login,
        register,
        logout,
        verifyEmail,
        resendVerification,
        refreshUser: loadUser
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

